module.exports = __webpack_public_path__ + "img/side-organization.b9588cbe.svg";